import React from 'react';

const CustomCheckbox = ({ checked, onChange, id }) => {
  return (
    <label className='custom-checkbox' htmlFor={id}>
      <input
        id={id}
        type='checkbox'
        className='custom-checkbox__input'
        checked={checked}
        onChange={onChange}
      />
      <span className='custom-checkbox__box'>
        <svg className='custom-checkbox__icon' viewBox='0 0 24 24' fill='none' stroke='currentColor'>
          <polyline points='20 6 9 17 4 12'></polyline>
        </svg>
      </span>
    </label>
  );
};

export default CustomCheckbox;
